// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import { messages, getStoredLocale, FALLBACK_LOCALE } from '@/locales'
import ElementLocale from 'element-ui/lib/locale'

// 挂载全局变量
import global from './global.js'
Vue.prototype.$global = global

// 移动端开启调试
import Vconsole from 'vconsole'
if (process.env.NODE_ENV !== 'production' && global.isMobile()) { // 测试和开发打开，生产不能打开
  let vConsole = new Vconsole()
  Vue.use(vConsole)
}

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import tool from "../src/utils/tool";
import mixins from '../src/mixin/index'
// 引入高德地图
import VueAMap from 'vue-amap';

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: getStoredLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  messages
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

Vue.use(tool);
Vue.mixin(mixins)
Vue.use(ElementUI);
Vue.use(VueAMap);
Vue.config.productionTip = false

// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德的key
  key: '2ac31afefda127cee169139029c96983',
  // 插件集合
  plugin: [],//'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  beforeCreate() {
    Vue.prototype.$bus = this //安装全局事件总线
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js